// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"453":"6a779bf8","1852":"0a14ea2b","2658":"8b5e8e54","2816":"5ee8033b","2841":"13ec22dd","7984":"6f725360"}[chunkId] + ".chunk.css";
};